import { makeCustomersRepository } from 'shared/infra/repositories';

import CreateWebchatLeadUseCase from './implementations/CreateWebchatLeadUseCase';

let instance: CreateWebchatLeadUseCase | null = null;

export default function makeCreateWebchatLeadUseCase() {
  if (!instance) {
    instance = new CreateWebchatLeadUseCase(makeCustomersRepository());
  }

  return instance;
}
